module.exports = __webpack_public_path__ + "img/LogoText_Lang2.d2cc3553.png";